import { useRef } from 'react';

const BACKGROUND_COLOR = '#f9f9f9';

export function useToggleBackground(element = 'tr') {
  const ref = useRef(null);

  const setBackground = (targetElement: HTMLElement) => {
    ref.current = targetElement.closest(element);
    if (ref.current) {
      ref.current.style.backgroundColor = BACKGROUND_COLOR;
    }
  };

  const resetBackground = () => {
    if (ref.current) ref.current.style.background = '';
  };

  return { setBackground, resetBackground };
}
